module.exports = __webpack_public_path__ + "img/dbe12c1cd53d13a5eaacb640bc7f0776.svg";